﻿import * as mobileServicing from './mobileServicing.api.js';

window.mobileServicing = mobileServicing;